'use client';
import { FlavorProps } from './_WoodPelletFlavor';
import Section from '@repo/ui/src/components/Section';
import GeneralCarousel from '@components/carousels/GeneralCarousel';

export interface Props {
  flavors: Array<FlavorProps>;
  pairsWithText: string;
  woodPelletsText: string;
}

const WoodPelletFlavors = ({ 
  flavors, 
  pairsWithText, 
  woodPelletsText, 
}: Props) => {

  const formattedFlavors = flavors?.map(flavor => ({
    ...flavor,
    pairsWithText,
    woodPelletsText,
    _meta: {
      schema: 'https://traegergrills.com/data/contentTypes/woodPelletFlavor.json'
    }
  }));

  return (
    <Section basePadding white gutterY className="tw-pt-10 md:tw-pt-20">
      <GeneralCarousel
        title={''}
        description={''}
        body={formattedFlavors}
        darkMode={false}
        whiteBackground={true}
        noPadding={false}
        maxVisibleCards={2.5}
      />
    </Section>
  );
};

export default WoodPelletFlavors;